module.exports = __webpack_public_path__ + "img/help-icon-dark.faa28601.svg";